
const WhyUsSection = () => {
  const stats = [
    { number: '500', label: 'مشروع منجز', icon: 'ri-building-line' },
    { number: '15', label: 'عام خبرة', icon: 'ri-time-line' },
    { number: '300', label: 'عميل راضٍ', icon: 'ri-user-smile-line' },
    { number: '24', label: 'دعم فني', icon: 'ri-customer-service-2-line' },
  ];

  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'جودة معتمدة عالمياً',
      description: 'نستخدم أفضل المعدات والأنظمة المعتمدة من الشركات العالمية الرائدة في مجال الأمن والحماية.',
    },
    {
      icon: 'ri-team-line',
      title: 'فريق محترف ومتخصص',
      description: 'فريق عمل مدرب على أعلى المستويات مع خبرة واسعة في تنفيذ المشاريع الكبرى والمعقدة.',
    },
    {
      icon: 'ri-tools-line',
      title: 'صيانة ودعم مستمر',
      description: 'نوفر خدمات صيانة دورية ودعم فني متواصل على مدار الساعة لضمان عمل الأنظمة بكفاءة.',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'أسعار تنافسية',
      description: 'نقدم أفضل الأسعار في السوق مع الحفاظ على أعلى معايير الجودة والاحترافية في التنفيذ.',
    },
  ];

  return (
    <section className="py-24 bg-navy text-white">
      <div className="container mx-auto px-6">
        {/* Stats Section */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {stats.map((stat, index) => (
            <div key={index} className="text-center relative">
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-4xl text-primary`}></i>
              </div>

              {/* Number */}
              <div className="text-5xl font-bold text-primary mb-2">
                {stat.number}
                <span className="text-3xl">+</span>
              </div>

              {/* Label */}
              <div className="text-base text-silver">{stat.label}</div>

              {/* Divider */}
              {index < stats.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 left-full w-px h-20 bg-primary/30 -translate-y-1/2"></div>
              )}
            </div>
          ))}
        </div>

        {/* Features Section */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            لماذا تختار <span className="text-primary">حلولنا الأمنية</span>؟
          </h2>
          <p className="text-lg text-silver max-w-2xl mx-auto">
            نتميز بالخبرة الواسعة والجودة العالية في تقديم الحلول الأمنية المتكاملة
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-10">
          {features.map((feature, index) => (
            <div key={index} className="flex items-start gap-6 group">
              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary/15 flex-shrink-0 group-hover:bg-primary transition-all duration-300">
                <i className={`${feature.icon} text-3xl text-primary group-hover:text-white transition-all duration-300`}></i>
              </div>

              {/* Content */}
              <div>
                <h3 className="text-2xl font-semibold mb-3">{feature.title}</h3>
                <p className="text-silver text-[15px] leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
